// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const Cal365Icon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={16} viewBox="0 0 20 16" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<defs><path id="path-1" d="M16.672 1.374v13.292h.001-.001v.016L11.909 16v-.004L3.333 12.83l8.576 1.18V2.513L6.25 3.867v7.82L3.328 12.83l-.001-9.611.021-.004L11.91 0Z" /></defs><g id="cal-365" fill="none" fillRule="evenodd" stroke="none"><path id="Path" fill="#EA3E23" d="m16.673 14.667-.001-.001V1.374L11.91 0 3.348 3.215l-.021.004v9.61l2.922-1.143v-7.82l5.66-1.353V14.01l-8.576-1.18 8.576 3.166V16l4.763-1.318v-.015z" /></g></svg>
))
